//
// Copyright 2024 DXOS.org
//

import { type ColorSememes } from './types';

// TODO(burdon): This should be broader than just calls.
export const callsSememes: ColorSememes = {
  callActive: {
    light: ['green', '500'],
    dark: ['green', '500'],
  },
  callAlert: {
    light: ['rose', '500'],
    dark: ['rose', '500'],
  },
};
